export default function getDigits (num: number): number {
  return Math.log(num) / Math.LN10 + 1 | 0
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/get-digits.ts